import React from 'react';

export const DashboardWidgetContext = React.createContext({
    descriptionExpanded: false,
    setDescriptionExpanded: (value: boolean) => {}
});
